/**
 * @generated SignedSource<<c2821ee4173b83408fe6d8e90a036574>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuDrawerAppliedFilterDisplay_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useMeasurementUnit_user">;
  readonly " $fragmentType": "SbRespRefineMenuDrawerAppliedFilterDisplay_user";
};
export type SbRespRefineMenuDrawerAppliedFilterDisplay_user$key = {
  readonly " $data"?: SbRespRefineMenuDrawerAppliedFilterDisplay_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespRefineMenuDrawerAppliedFilterDisplay_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuDrawerAppliedFilterDisplay_user",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_user",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserPreferences",
          "kind": "LinkedField",
          "name": "preferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "measurementUnit",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "eb721814f3d30d72590c56260c12f3af";

export default node;
